<!-- List of items, each with their own icon. Items must be SbListWithIconsItem -->
<template>
	<ul
		role="list"
		class="divide-y divide-gray-200"
	>
		<li
			v-for="item in blok?.items"
			:key="item._uid"
			class="py-4"
		>
			<component
				:is="item.component"
				:blok="item"
			/>
		</li>
	</ul>
</template>

<script setup lang="ts">
import type { ListWithIconsStoryblok } from '@/sbTypes'
import { type PropType } from 'vue'

defineProps({
	blok: Object as PropType<ListWithIconsStoryblok>,
})
</script>
